import type { OptionState } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export const useBrowserOptionsFetch = ({ enabled }: { enabled: boolean }): OptionState => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    skip: !enabled,
    variables: {
      path: 'deal.package.targeting.technographic.browser',
    },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [];
    }

    return optionsByPath.map(option =>
      option
        ? {
            id: option.id,
            name: option.name,
            ...option.extra,
          }
        : []
    );
  }, [optionsByPath]);

  const mapById = useMemo(() => {
    return list
      .map(option => ({ [option.id]: option }))
      .reduce((acc, curr) => {
        return Object.assign(acc, curr);
      }, {});
  }, [list]);

  return {
    list,
    loading,
    mapById,
  };
};
